/* eslint-disable no-unused-vars */
export enum StatusRequest {
  PENDING = 'Pending',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
